import { styled } from "@linaria/react"
import { useEffect, useState } from "react"

import { getLogger } from "@/lib/logging.ts"

import type { ReactNode } from "react"


type WithImageProps = {
  path: string
  image: Promise<string>
  width: number
  height: number
  children: (image: string) => ReactNode
}

const resolvedImages: Map<string, string> = new Map<string, string>()

const log = getLogger("WithImage")

export const WithImage = ({ path, image, width, height, children }: WithImageProps) => {
  const [resolvedImage, setResolvedImage] = useState(resolvedImages.get(path))

  useEffect(() => {
    if (resolvedImages.get(path)) {
      setResolvedImage(resolvedImages.get(path))
    } else {
      image.then((result) => {
        resolvedImages.set(path, result)
        setResolvedImage(result)
      }).catch((e) => log.error("Failed to load", e))
    }
  }, [path, image])

  return resolvedImage ? children(resolvedImage) : <ImagePlaceholder width={width} height={height} />
}

const ImagePlaceholder = styled.div<{
  width: number
  height: number
}>`
  display: inline-block;
  width: ${props => `${props.width}px`};
  height: ${props => `${props.height}px`};
`